<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运营商申请售后</el-breadcrumb-item>
      <el-breadcrumb-item>申请换货</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords.status" placeholder="请选择" class="select">
              <el-option label="请选择订单状态" value="-1"></el-option>
              <el-option label="已创建" value="0"></el-option>
              <el-option label="已审核" value="1"></el-option>
              <el-option label="已发货" value="2"></el-option>
              <el-option label="仓库确认收货" value="3"></el-option>
              <el-option label="仓库回寄" value="4"></el-option>
              <el-option label="运营商确认收货" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.bomsn" placeholder="请选择产品" class="select2">
              <el-option label="请选择产品名称" value=""></el-option>
              <el-option
                v-for="item in optionsproduct" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->
        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="statuss" label="状态" min-width="8%"></el-table-column>
          <el-table-column prop="productname" label="产品名称" min-width="8%"></el-table-column>
          <el-table-column prop="jigouname" label="机构名称" min-width="11%"></el-table-column>
          <el-table-column prop="cardnumber" label="设备编号" min-width="11%"></el-table-column>
          <el-table-column prop="logisticsname1" label="物流公司(发货给仓库)" min-width="8%"></el-table-column>
          <el-table-column prop="logisticsid1" label="物流单号(发货给仓库)" min-width="7%"></el-table-column>
          <el-table-column prop="dlsaddress" label="运营商收货地址" min-width="5%"></el-table-column>
          <el-table-column prop="dlsname" label="运营商联系人姓名" min-width="5%"></el-table-column>
          <el-table-column prop="dlsphone" label="运营商联系人手机" min-width="5%"></el-table-column>
          <el-table-column prop="logisticsname2" label="物流公司(发货给运营商)" min-width="5%"></el-table-column>
          <el-table-column prop="logisticsid2" label="物流单号(发货给运营商)" min-width="5%"></el-table-column>
          <el-table-column prop="createtime" label="创建时间" min-width="10%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="12%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.status == 0 && SubRule_ErpDlsReturns_ReviewHuanhuo" @click="clickReviewHuanhuo(scope.row)">审核换货申请</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.status == 1 && SubRule_ErpDlsReturns_SendHuanhuo" @click="clicksendHuanhuo(scope.row)">运营商发货</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.status == 2 && SubRule_ErpDlsReturns_SendOkHuanhuo" @click="clicksendOkHuanhuo(scope.row)">仓库确认收货</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.status == 3 && SubRule_ErpDlsReturns_ReSendHuanhuo" @click="clickReSendHuanhuo(scope.row)">仓库回寄</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.status == 4 && SubRule_ErpDlsReturns_ReSendOkHuanhuo" @click="clickReSendOkHuanhuo(scope.row)">运营商确认回寄</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->
        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 运营商发货弹出框 -->
    <el-dialog title="运营商发货" :visible.sync="SendHuanhuodialog" width="30%" :close-on-click-modal="false">
      <el-form :model="SendHuanhuoForm" ref="SendHuanhuoFormRef" label-width="70px">
        <el-form-item label="物流公司" class="addAdminForm">
          <el-input v-model="SendHuanhuoForm.logisticsname1" placeholder="请输入物流公司(发货给仓库)"></el-input>
        </el-form-item>
        <el-form-item label="物流单号" class="addAdminForm">
          <el-input v-model="SendHuanhuoForm.logisticsid1" placeholder="请输入物流单号(发货给仓库)"></el-input>
        </el-form-item>
        <el-form-item label="收货地址" class="addAdminForm">
          <el-input v-model="SendHuanhuoForm.dlsaddress" placeholder="请输入运营商收货地址"></el-input>
        </el-form-item>
        <el-form-item label="姓名" class="addAdminForm">
          <el-input v-model="SendHuanhuoForm.dlsname" placeholder="请输入运营商联系人姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机" class="addAdminForm">
          <el-input v-model="SendHuanhuoForm.dlsphone" placeholder="请输入运营商联系人手机"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksaveSendHuanhuo">发货</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 运营商发货弹出框 end -->

    <!-- 仓库回寄弹出框 -->
    <el-dialog title="仓库回寄" :visible.sync="ReSendHuanhuodialog" width="30%" :close-on-click-modal="false">
      <el-form :model="ReSendHuanhuoForm" ref="ReSendHuanhuoFormRef" label-width="70px">
        <el-form-item label="物流公司" class="addAdminForm">
          <el-input v-model="ReSendHuanhuoForm.logisticsname2" placeholder="物流公司(发货给运营商)"></el-input>
        </el-form-item>
        <el-form-item label="物流单号" class="addAdminForm">
          <el-input v-model="ReSendHuanhuoForm.logisticsid2" placeholder="物流单号(发货给运营商)"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksaveReSendHuanhuo">发货</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 仓库回寄弹出框 end -->

    <!-- 申请换货 start -->
    <el-tab-pane label="申请换货" v-if="SubRule_ErpDlsReturns_ApplyHuanhuo" name="second">
      <el-form :model="addForm" ref="addFormRef" label-width="70px">
        <el-form-item label="产品名称" class="addAdminForm">
            <el-select v-model="addForm.bomsn" placeholder="请选择产品" class="select2">
              <el-option
                v-for="item in optionsproduct" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="保修卡号" class="addAdminForm">
          <el-input v-model="addForm.cardnumber" placeholder="请输入保修卡号后8位,然后点击校验按钮"></el-input>
          <el-button type="success" plain @click="apicheckcardnumber">校验</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">申请</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 申请换货 end -->
  </el-tabs>
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou
  },
  name: 'MyErpDlsReturnsHuan',
  data () {
    return {
      activeName: 'first',
      optionsproduct: [],
      addForm: {
        bomsn: '',
        cardnumber: ''
      },
      timer: '',
      // 查询
      keywords: {
        status: '-1',
        bomsn: '',
        jigouid: '-1',
        jigouname: ''
      },
      dataList: [],
      dataListnum: 0,
      SendHuanhuodialog: false,
      SendHuanhuoForm: {
        id: '',
        logisticsname1: '',
        logisticsid1: '',
        dlsaddress: '',
        dlsname: '',
        dlsphone: ''
      },
      ReSendHuanhuodialog: false,
      ReSendHuanhuoForm: {
        id: '',
        logisticsname2: '',
        logisticsid2: ''
      },
      selectedPageNo: 1,
      SubRule_ErpDlsReturns_ApplyHuanhuo: false,
      SubRule_ErpDlsReturns_ReviewHuanhuo: false,
      SubRule_ErpDlsReturns_SendHuanhuo: false,
      SubRule_ErpDlsReturns_SendOkHuanhuo: false,
      SubRule_ErpDlsReturns_ReSendHuanhuo: false,
      SubRule_ErpDlsReturns_ReSendOkHuanhuo: false
    }
  },
  mounted () {
    this.apiGetWorkprojectList()
    this.apigetDlsReturnsHuannum()
    this.apigetDlsReturnsHuanlist()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsReturns_ApplyHuanhuo', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsReturns_ApplyHuanhuo = true
      }
    })

    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsReturns_ReviewHuanhuo', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsReturns_ReviewHuanhuo = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsReturns_SendHuanhuo', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsReturns_SendHuanhuo = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsReturns_SendOkHuanhuo', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsReturns_SendOkHuanhuo = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsReturns_ReSendHuanhuo', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsReturns_ReSendHuanhuo = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsReturns_ReSendOkHuanhuo', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsReturns_ReSendOkHuanhuo = true
      }
    })
  },
  methods: {
    clickReviewHuanhuo (row) {
      this.$confirm('是否同意运营商的换货申请?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apieditDlsReturnsHuanshenhe(row.id)
      })
    },
    clicksendHuanhuo (row) {
      this.SendHuanhuodialog = true
      this.SendHuanhuoForm.id = row.id
      this.SendHuanhuoForm.logisticsname1 = ''
      this.SendHuanhuoForm.logisticsid1 = ''
      this.SendHuanhuoForm.dlsaddress = ''
      this.SendHuanhuoForm.dlsname = ''
      this.SendHuanhuoForm.dlsphone = ''
    },
    clicksendOkHuanhuo (row) {
      this.$confirm('是否确认收货?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apieditDlsReturnsHuanSendOk(row.id)
      })
    },
    clickReSendHuanhuo (row) {
      this.ReSendHuanhuodialog = true
      this.ReSendHuanhuoForm.id = row.id
      this.ReSendHuanhuoForm.logisticsname2 = ''
      this.ReSendHuanhuoForm.logisticsid2 = ''
    },
    clickReSendOkHuanhuo (row) {
      this.$confirm('是否确认收货?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apieditDlsReturnsHuanReSendOk(row.id)
      })
    },
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clickadd () {
      if (!this.addForm.cardnumber) {
        this.$alert('请输入保修卡号', '提示')
        return
      }
      this.apiaddDlsReturnsHuan()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clicksaveSendHuanhuo () {
      if (!this.SendHuanhuoForm.logisticsname1) {
        this.$alert('请输入物流公司(发货给仓库)', '提示')
        return
      }
      if (!this.SendHuanhuoForm.logisticsid1) {
        this.$alert('请输入物流单号(发货给仓库)', '提示')
        return
      }
      if (!this.SendHuanhuoForm.dlsaddress) {
        this.$alert('请输入运营商收货地址', '提示')
        return
      }
      if (!this.SendHuanhuoForm.dlsname) {
        this.$alert('请输入运营商联系人姓名', '提示')
        return
      }
      if (!this.SendHuanhuoForm.dlsphone) {
        this.$alert('请输入运营商联系人手机', '提示')
        return
      }
      this.apieditDlsReturnsHuanSend()
    },
    clicksaveReSendHuanhuo () {
      if (!this.ReSendHuanhuoForm.logisticsname2) {
        this.$alert('请输入物流公司', '提示')
        return
      }
      if (!this.ReSendHuanhuoForm.logisticsid2) {
        this.$alert('请输入物流单号', '提示')
        return
      }
      this.apieditDlsReturnsHuanReSend()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apigetDlsReturnsHuannum()
      this.apigetDlsReturnsHuanlist()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apigetDlsReturnsHuanlist()
    },
    apiGetWorkprojectList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkprojectList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.optionsproduct = []
            response.data.List.filter((item1, i1) => {
              if (item1.Bomtype == 1) {
                that.optionsproduct.push({ value: item1.Bomsn, label: item1.Name })
              }
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetDlsReturnsHuannum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        status: that.keywords.status,
        bomsn: that.keywords.bomsn,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetDlsReturnsHuannum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetDlsReturnsHuanlist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        status: that.keywords.status,
        bomsn: that.keywords.bomsn,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetDlsReturnsHuanlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = []
            response.data.List.filter((item1, i1) => {
              that.dataList.push({ id: item1.Id, status: item1.Status, statuss: item1.Statuss, bomsn: item1.Bomsn, productname: item1.Productname, jigouid: item1.Jigouid, jigouname: item1.Jigouname, cardnumber: item1.Cardnumber, logisticsname1: item1.Logisticsname1, logisticsid1: item1.Logisticsid1, dlsaddress: item1.Dlsaddress, dlsname: item1.Dlsname, dlsphone: item1.Dlsphone, logisticsname2: item1.Logisticsname2, logisticsid2: item1.Logisticsid2, createtime: item1.Createtime })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiaddDlsReturnsHuan: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: this.addForm.bomsn,
        cardnumber: this.addForm.cardnumber
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddDlsReturnsHuan, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apigetDlsReturnsHuannum()
            that.apigetDlsReturnsHuanlist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditDlsReturnsHuanshenhe: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditDlsReturnsHuanshenhe, Qs.stringify(data))
        .then(function (response) {
          that.apigetDlsReturnsHuanlist()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditDlsReturnsHuanSend: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.SendHuanhuoForm.id,
        logisticsname1: this.SendHuanhuoForm.logisticsname1,
        logisticsid1: this.SendHuanhuoForm.logisticsid1,
        dlsaddress: this.SendHuanhuoForm.dlsaddress,
        dlsname: this.SendHuanhuoForm.dlsname,
        dlsphone: this.SendHuanhuoForm.dlsphone
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditDlsReturnsHuanSend, Qs.stringify(data))
        .then(function (response) {
          that.apigetDlsReturnsHuanlist()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.SendHuanhuodialog = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditDlsReturnsHuanSendOk: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditDlsReturnsHuanSendOk, Qs.stringify(data))
        .then(function (response) {
          that.apigetDlsReturnsHuanlist()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditDlsReturnsHuanReSend: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.ReSendHuanhuoForm.id,
        logisticsname2: this.ReSendHuanhuoForm.logisticsname2,
        logisticsid2: this.ReSendHuanhuoForm.logisticsid2
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditDlsReturnsHuanReSend, Qs.stringify(data))
        .then(function (response) {
          that.apigetDlsReturnsHuanlist()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.ReSendHuanhuodialog = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditDlsReturnsHuanReSendOk: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditDlsReturnsHuanReSendOk, Qs.stringify(data))
        .then(function (response) {
          that.apigetDlsReturnsHuanlist()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apicheckcardnumber: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        cardnumber: that.addForm.cardnumber
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_CheckCardnumberJigou, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.addForm.cardnumber = response.data.Cardnumber
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
